import React, { useState } from "react";
import { useLanguage } from "../../../context/LanguageContext";
import { CourseCard } from "../../../components/CourseCard";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";
import { CoursesData } from "../../../lib/languages";
import { useNavigate } from "react-router-dom";
import { useAPI } from "../../../context/APIContext";

export default function TeacherCourses() {
  const navigate = useNavigate();

  const { TeacherCoursesItems } = useAPI();
  const { loadingTeacherCourses, teacherCourses, getAllTeacherCourses } =
    TeacherCoursesItems;

  const { language } = useLanguage();
  const t = CoursesData[language] || CoursesData["en"];

  const [sortBy, setSortBy] = useState("latest");

  const sortedCourses = [...teacherCourses].sort((a, b) => {
    if (sortBy === "latest") return b.id - a.id; // Newest courses first
    if (sortBy === "rating") return b.rating - a.rating; // Highest rated first
    if (sortBy === "price") return a.rating - b.rating; // Assuming lower rating means cheaper course
    return 0;
  });

  return (
    <div className="space-y-6" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="flex items-center justify-between gap-2">
        <p className="font-bold text-2xl">Courses</p>
        <Select onValueChange={setSortBy} defaultValue={sortBy}>
          <SelectTrigger className="w-[9rem]">
            <SelectValue placeholder={t.sortBy} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="latest">{t.latest}</SelectItem>
            <SelectItem value="rating">{t.rating}</SelectItem>
            <SelectItem value="price">{t.price}</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {sortedCourses.map((item, index) => (
          <CourseCard
            key={index}
            item={item}
            btnTitle={"Show Course"}
            onClick={() => navigate(`/teacher/course-view/${item.id}`)}
          />
        ))}
      </div>
    </div>
  );
}
